<dx-popup
    [title]="dialogHeader"
    [width]="dialogWidth"
    [height]="'auto'"
    [(visible)]="visible"
    [hideOnOutsideClick]="false"
    (onHiding)="onHiding($event)"
>
    <dxi-popup-toolbar-item widget="dxButton" location="after" [options]="{ icon: 'save', text: 'Save', type: 'success', onClick: onSave }">
    </dxi-popup-toolbar-item>
    <dxi-popup-toolbar-item
        widget="dxButton"
        location="after"
        [options]="{ icon: 'save', text: 'Save And New', type: 'success', visible: saveAndNewVisible, onClick: onSaveAndNew }"
    >
    </dxi-popup-toolbar-item>
    <dxi-popup-toolbar-item
        widget="dxButton"
        location="after"
        [options]="{ icon: 'close', text: 'Cancel', type: 'default', onClick: cancel }"
    >
    </dxi-popup-toolbar-item>
    <div class="modal-body" (keyup.esc)="cancel()" (keyup.enter)="enterPressed()">
        @if (dialogPrompt) {
            <div class="mb-2">{{ dialogPrompt }}</div>
        }
        @if (mode === 'text') {
            <div>
                <dx-text-box #inputComponent [(value)]="dialogValue" valueChangeEvent="input"></dx-text-box>
            </div>
        }
        @if (mode === 'password') {
            <div>
                <dx-text-box
                    #inputComponent
                    [(value)]="dialogValue"
                    [mode]="'password'"
                    valueChangeEvent="input"
                    (onInput)="onInput($event)"
                ></dx-text-box>
            </div>
        }
        @if (mode === 'textarea') {
            <div>
                <dx-text-area #inputComponent [(value)]="dialogValue" [height]="300"></dx-text-area>
            </div>
        }
        @if (mode === 'select') {
            <div>
                <dx-select-box #inputComponent [(value)]="dialogValue" [items]="dialogValueArray"></dx-select-box>
            </div>
        }
        @if (mode === 'selectWithId') {
            <div>
                <dx-select-box
                    #inputComponent
                    [(value)]="dialogValue"
                    [items]="dialogValueArray"
                    [valueExpr]="'id'"
                    [displayExpr]="'name'"
                ></dx-select-box>
            </div>
        }
        @if (mode === 'date') {
            <div>
                <dx-date-box #inputComponent [(value)]="dialogValue"></dx-date-box>
            </div>
        }
        @if (mode === 'datetime') {
            <div>
                <dx-date-box #inputComponent type="datetime" [(value)]="dialogValue"></dx-date-box>
            </div>
        }
        @if (!!dialogMessage) {
            <div class="mt-3">
                {{ dialogMessage }}
            </div>
        }
    </div>
</dx-popup>
